'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _ethCrypto = require('eth-crypto');

var _ethCrypto2 = _interopRequireDefault(_ethCrypto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { toBuffer } from 'ethereumjs-util';

// TODO: Add @param version to the encrypt and decrypt functions for version control
// Check this: https://github.com/MetaMask/eth-sig-util/pull/18#issuecomment-384399986

/**
 * ECIES encrypt
 * @param {Buffer|String} pubKeyTo Ethereum pub key, 64 bytes
 * @param {Buffer|String} plaintext Plaintext to be encrypted
 * optional iv (16 bytes) and ephem key (32 bytes)
 * @returns {Buffer} Encrypted message, serialized, 113+ bytes
 */
var encrypt = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(pubKeyTo, plaintext) {
    var hexPubKeyString, hexPubKey, payload, encrypted;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            hexPubKeyString = pubKeyTo.toString('hex');
            hexPubKey = hexPubKeyString.substr(0, 2) === '0x' ? hexPubKeyString.toString('hex').substr(2) : hexPubKeyString.toString('hex');
            payload = {
              message: plaintext
            };
            _context.next = 5;
            return _ethCrypto2.default.encryptWithPublicKey(hexPubKey, (0, _stringify2.default)(payload));

          case 5:
            encrypted = _context.sent;
            return _context.abrupt('return', _ethCrypto2.default.cipher.stringify(encrypted));

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function encrypt(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * ECIES decrypt
 * @param {Buffer|String} privKey Ethereum private key, 32 bytes
 * @param {Buffer|String} encrypted Encrypted message, serialized, 113+ bytes
 * @returns {Buffer} plaintext
 */
var decrypt = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(privKey, encrypted) {
    var hexPrivKeyString, hexPrivKey, encryptedObject, decrypted, decryptedPayload;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            hexPrivKeyString = privKey.toString('hex');
            hexPrivKey = hexPrivKeyString.substr(0, 2) === '0x' ? hexPrivKeyString : '0x' + hexPrivKeyString;
            encryptedObject = _ethCrypto2.default.cipher.parse(encrypted);
            _context2.next = 5;
            return _ethCrypto2.default.decryptWithPrivateKey(hexPrivKey, encryptedObject);

          case 5:
            decrypted = _context2.sent;
            decryptedPayload = JSON.parse(decrypted);
            return _context2.abrupt('return', decryptedPayload.message);

          case 8:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function decrypt(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

/* eslint-disable */

var truffleHack = function truffleHack(contract) {
  if (typeof contract.currentProvider.sendAsync !== 'function') {
    contract.currentProvider.sendAsync = function () {
      return contract.currentProvider.send.apply(contract.currentProvider, arguments);
    };
  }
  return contract;
};

/* eslint-enable */

exports.default = {
  encrypt: encrypt,
  decrypt: decrypt,
  truffleHack: truffleHack
};
module.exports = exports['default'];
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@linniaprotocol/linnia-js/lib/util.js
// module id = 562
// module chunks = 0